import React from 'react';
import { useGetOptions, SelectInputProps } from "../../../../../hooks/report/useGetOptions";
import { BoundSelect } from "../BoundSelect";
import { YesNo } from "../../../../constants/securspace-constants";

type BoundYesNoSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundYesNoSelect = <T,>({
  label = "Yes or No",
  name,
  value = '',
  onChange
}: BoundYesNoSelectProps<T>) => {

  return <BoundSelect<T>
    options={useGetOptions({optionFormat: 'SELECT', options: YesNo}) as unknown as SelectInputProps[]}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundYesNoSelect };